import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Card, CardHeader, CardText, Paper } from 'material-ui';
import ExternalFiles from './external-files';
import RespondedContractList from './responded-contract-list';
import moment from 'moment';
import RateConversion from '../../../dummy-account/rate-conversion';
import PartnerNode from '../partner-node';


const propTypes = {
  contractId: PropTypes.string,
  buyerInfo: PropTypes.object,
  contractorEditable: PropTypes.bool,
  openAddEditContractDialog: PropTypes.func,
  isLatest: PropTypes.bool,
  from: PropTypes.object,
  to: PropTypes.object,
  partners: PropTypes.array,
  contacts: PropTypes.array,
  deadlineDate: PropTypes.string,
  rateConversionStatus: PropTypes.string,
  rateConversionSetting: PropTypes.string,
  respondedContracts: PropTypes.array,
  files: PropTypes.array,
};

const CRBuyerView = props =>  {
  const {
    deadlineDate,
    partners,
    contacts,
    rateConversionStatus,
    respondedContracts = [],
    files = [],
  } = props;

  const converting = rateConversionStatus !== 'Awaiting Supplier Rates'
    && rateConversionStatus !== 'Conversion Complete' && rateConversionStatus !== 'Signed';
  return (
    <div style={{ padding: '2% 5%' }}>
      <Card style={{ marginTop: '1em' }}>
        <CardHeader
          title={`Files (${files.length})`}
          titleStyle={{ fontSize: '16px', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.67)', textTransform: 'uppercase' }}
          actAsExpander
          showExpandableButton
        />
        <CardText expandable style={{ padding: '1em 2em' }}>
          <ExternalFiles/>
        </CardText>
      </Card>
      <Card
        style={{ marginTop: '1em' }}
        initiallyExpanded={Boolean(respondedContracts.length)}
      >
        <CardHeader
          title={`TourConnect Format Rate Contracts (${respondedContracts.length})`}
          titleStyle={{ fontSize: '16px', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.67)', textTransform: 'uppercase' }}
          actAsExpander
          showExpandableButton
        />
        <CardText expandable style={{ padding: '1em 2em' }}>
          <RespondedContractList/>
        </CardText>
      </Card>
      <Card
        style={{ marginTop: '1em' }}
        initiallyExpanded={converting}
      >
        <CardHeader
          title="Rate Conversion"
          titleStyle={{ fontSize: '16px', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.67)', textTransform: 'uppercase' }}
          actAsExpander
          showExpandableButton
        />
        <CardText expandable style={{ padding: '1em 2em' }}>
          <RateConversion/>
        </CardText>
      </Card>
      <Card style={{ marginTop: '1em' }}>
        <CardHeader
          title="Request Details (Deadline & Notes)"
          titleStyle={{ fontSize: '16px', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.67)', textTransform: 'uppercase' }}
          actAsExpander
          showExpandableButton
        />
        <CardText expandable style={{ padding: '1em 2em' }}>
          <Paper
            style={{
              width: '400px',
              marginLeft: '24px',
              padding: '24px',
              border: '1px solid #e0e0e0',
              borderRadius: '5px',
            }}
          >
            <PartnerNode
              forWS
              isReceiver
              forSupplier
              partners={partners}
              contacts={contacts}
            />
          </Paper>
          <div>
            <div style={{ fontWeight: 'bolder' }}>Rate Submission Deadline</div>
            <div style={{ margin: '1em 0 1em 0' }}>{ deadlineDate ? moment.utc(new Date(deadlineDate)).format('MMMM DD, YYYY') : 'NA' }</div>
          </div>
        </CardText>
      </Card>
    </div>
  );
};

CRBuyerView.propTypes = propTypes;

export default connect(({ contracting }) => {
  const leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  const rightSideContent = contracting.contractActivitiesProducts.get('rightSideContent').toJS();
  return {
    contractId: leftNav.contractId,
    viewingAs: leftNav.viewingAs,
    partners: leftNav.partners,
    contacts: leftNav.contacts,
    from: leftNav.from,
    to: leftNav.to,
    rateConversionStatus: rightSideContent.rateConversionStatus,
    rateConversionSetting: rightSideContent.rateConversionSetting,
    isLatest: leftNav.isLatest,
    deadlineDate: rightSideContent.deadlineDate,
    buyerInfo: rightSideContent.buyerInfo,
    files: rightSideContent.files,
    respondedContracts: leftNav.respondedContracts,
  };
})(CRBuyerView);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-policies/contract-request-buyer-view/old-router.jsx